import * as React from "react";
import {
  ChakraProvider,
  Box,
  Text,
  Link,
  VStack,
  Code,
  Grid,
  theme,
  Stack,
} from "@chakra-ui/react";
import { ColorModeSwitcher } from "./components/ColorModeSwitcher";
import { Logo } from "./Logo";
import {
  Route,
  BrowserRouter as Router,
  Routes,
  useLocation,
  useNavigate,
} from "react-router-dom";
import Login from "./screens/Login";
import Dashboard from "./screens/Dashboard";
import SalesOrder from "./screens/SalesOrder";
import Cookies from "js-cookie";
import Reports from "./screens/Report";
import PurchaseOrder from "./screens/PurchaseOrder";
import Analytics from "./screens/Analytics";
import CustomerScreen from "./screens/Customers";
import PendingOrdersScreen from "./screens/PendingOrders";
import RecentOrdersScreen from "./screens/RecentOrders";
import OrderDetailsScreen from "./screens/OrderDetails";
import RecentPaymentsScreen from "./screens/RecentPayments";
import ExpenseDetailsScreen from "./screens/ExpenseDetails";
import RecentExpensesScreen from "./screens/RecentExpenses";
import CustomerOrdersScreen from "./screens/CustomerOrders";
import CustomerPaymentsScreen from "./screens/CustomerPayments";
import PaymentsScreen from "./screens/Payments";
import Logins from "./screens/Logins";
import ChangePassword from "./screens/ChangePassword";
import AccountsScreen from "./screens/Accounts";
import AccountTransferScreen from "./screens/AccountTransfer";
import AccountStatement from "./screens/AccountStatement";
import ProductsScreen from "./screens/Products";
import SalesOrderGeneral from "./screens/SalesOrderGeneral";
import SupplierScreen from "./screens/Suppliers";
import AccountTransferExternalScreen from "./screens/AccountTransferExternal";
import CustomerAnalyticsScreen from "./screens/CustomerAnalytics";
import SupplierOrdersScreen from "./screens/SupplierOrders";
import Settings from "./screens/Settings";
import PredictionTest from "./screens/PredictionTest";
import axios from "axios";
import { getHeadersForRequest } from "./utils/functions";
import FryerScreen from "./screens/Fryer";
import FryerSessionDetails from "./screens/FryerSessionDetails";
import ProductionScreen from "./screens/Production";
import ProductionSessionDetails from "./screens/ProductionSessionDetails";
import DailyCallReportForm from "./screens/PapaDCR";
import StockScreen from "./screens/Stock";
import CreditNote from "./screens/CreditNote";
import 'leaflet/dist/leaflet.css';
import { LoadScript } from "@react-google-maps/api";
import { AddCustomer } from "./components/AddCustomer";
import CustomerMapScreen from "./screens/CustomerMap";
import { NotificationListener } from "./components/TestNotification";
import PaymentsGivenScreen from "./screens/PaymentsGiven";
import StockAnalyticsScreen from "./screens/StockAnalytics";
import Base64 from "./components/base64";
import CustomerPresetPricesScreen from "./screens/CustomerPresetPrices";
import MobileFloatingIsland from "./components/MobileFloatingIsland";
import { FiHome, FiSearch, FiPlusCircle, FiBell, FiUser, FiSettings, FiFile } from "react-icons/fi";
import { FaFileInvoice, FaFileInvoiceDollar } from "react-icons/fa";
import { HiDocumentReport, HiOutlineDocumentReport } from "react-icons/hi";
import { GiBarbecue, GiCookingPot  } from "react-icons/gi";
import { ServerStatsScreen } from "./screens/ServerStats";
import { PDFCompareScreen } from "./screens/PDFCompare";
const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_API_KEY;
const libraries: ("places")[] = ["places"];


const App = () => {
  const [isPageVisible, setIsPageVisible] = React.useState(!document.hidden);

  React.useEffect(() => {
    const handleVisibilityChange = () => setIsPageVisible(!document.hidden);
    document.addEventListener("visibilitychange", handleVisibilityChange);
    return () => document.removeEventListener("visibilitychange", handleVisibilityChange);
  }, []);

  const didInitNotifications = React.useRef(false);

  React.useEffect(() => {
    if (didInitNotifications.current) return;
    didInitNotifications.current = true;
  
    // 1️⃣ Check support
    if (
      typeof window !== "undefined" &&
      "Notification" in window &&
      typeof Notification.requestPermission === "function"
    ) {
      // 2️⃣ Only request if still "default" (i.e. not granted/denied)
      if (Notification.permission === "default") {
        Notification.requestPermission()
          .then((permission) => {
            console.log("Notification permission:", permission);
          })
          .catch((err) => {
            console.warn("Notification permission request failed:", err);
          });
      } else {
        console.log("Notification permission already set to:", Notification.permission);
      }
    } else {
      // e.g. on iPad Safari/web where Notification API isn’t supported
      console.log("Notifications API not supported in this environment.");
    }
  }, []);

  const navigate = useNavigate();

  const validateToken = async () => {
    try {
      const headers = await getHeadersForRequest();
      const response = await axios.post(
        `${process.env.REACT_APP_TEST_API_URL}/auth/tokenValidation`,
        {
          emailAddress : headers?.emailAddress,
          accessToken : headers?.userToken,
          deviceId : headers?.deviceId,
        }
      );
      console.log(response);
      if (response.data.status === 200) {
        navigate("/dashboard");
      } else {
        navigate("/login");
      }
    } catch (err) {
      console.error(err);
      navigate("/login");
    }
  };

  // React.useEffect(() => {
  //   Notification.requestPermission();
  // }, []);

  React.useEffect(() => {
    const user = Cookies.get("userToken");
    if (user) {
      // navigate("/dashboard");
      validateToken();
      console.log("user");
    } else {
      navigate("/login");
      console.log("noUser");
    }
  }, []);
  
  const location = useLocation();
  const pathname = location.pathname;

  const defaultMobileMenu = [
      { label: "Home", icon: FiHome, href: "#home", onClick: () => {navigate("/dashboard")}, isActive: pathname === "/dashboard" },
      { label: "Invoice", icon: HiOutlineDocumentReport, href: "Reports", onClick: () => {navigate("/dashboard/Reports")}, isActive: pathname === "/dashboard/Reports" },
      { label: "New", icon: FiPlusCircle, href: "SalesCalculator", onClick: () => {navigate("/dashboard/SalesCalculator")}, isActive: pathname === "/dashboard/SalesCalculator" },
      { label: "Alerts", icon: GiBarbecue , onClick: () => {navigate("/dashboard/Production")}, isActive: pathname === "/dashboard/Production" },
      { label: "Settings", icon: FiSettings, onClick: () => {navigate("/settings")}, isActive: pathname === "/settings"  },
    ];

  return (
    <ChakraProvider theme={theme}>
      {/* <Box textAlign="center" fontSize="xl"> */}
      <Stack 
  //  minH="100vh"
  // bgGradient="linear(135deg, #0f2027, #203a43, #2c5364)"
      >
      {/* <ColorModeSwitcher justifySelf="flex-end" /> */}
      {isPageVisible && <NotificationListener />}
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/dashboard" element={<Dashboard />} />
        <Route path="/Logins" element={<Logins />} />
        <Route path="/ChangePassword" element={<ChangePassword />} />
        <Route path="/dashboard/SalesCalculator" element={<SalesOrder />} />
        <Route
          path="/dashboard/SalesCalculatorGeneral"
          element={<SalesOrderGeneral />}
        />
        <Route
          path="/dashboard/ExpensesCalculator"
          element={<PurchaseOrder />}
        />

        <Route path="/dashboard/CreditNote" element={<CreditNote />} />
        <Route path="/dashboard/Payments" element={<PaymentsScreen />} />
        <Route path="/dashboard/PaymentsGiven" element={<PaymentsGivenScreen />} />
        <Route
          path="/dashboard/Transfers"
          element={<AccountTransferScreen />}
        />
        <Route
          path="/dashboard/TransfersExternal"
          element={<AccountTransferExternalScreen />}
        />
        <Route path="/Settings" element={<Settings />} />
        <Route path="/PredictionTest" element={<PredictionTest />} />
        <Route path="/dashboard/Reports" element={<Reports />} />
        <Route path="/dashboard/Analytics" element={<Analytics />} />
        <Route path="/dashboard/Products" element={<ProductsScreen />} />
        <Route path="/dashboard/Fryer" element={<FryerScreen />} />
        <Route path="/dashboard/Production" element={<ProductionScreen />} />
        <Route path="/dashboard/Customers" element={<CustomerScreen />} />
        <Route path="/dashboard/Suppliers" element={<SupplierScreen />} />
        <Route path="/dashboard/Accounts" element={<AccountsScreen />} />
        <Route
          path="/dashboard/PendingOrders"
          element={<PendingOrdersScreen />}
        />
        <Route
          path="/dashboard/RecentOrders"
          element={<RecentOrdersScreen />}
        />
        <Route path="/OrderDetails/:orderId" element={<OrderDetailsScreen ID={""}/>} />
        <Route
          path="/dashboard/RecentPayments"
          element={<RecentPaymentsScreen />}
        />
        <Route
          path="/dashboard/Stock"
          element={<StockScreen />}
        />
        <Route
          path="/StockAnalytics/:description"
          element={<StockAnalyticsScreen />}
        />
        <Route
          path="/dashboard/RecentExpenses"
          element={<RecentExpensesScreen />}
        />
        <Route
          path="/ExpenseDetails/:orderId"
          element={<ExpenseDetailsScreen ID={""} />}
        />
        <Route
          path="/AccountStatement/:accountId/:accountName"
          element={<AccountStatement />}
        />
        <Route
          path="/FryerSessionDetails/:sessionId"
          element={<FryerSessionDetails />}
        />
        <Route
          path="/ProductionSessionDetails/:sessionId"
          element={<ProductionSessionDetails />}
        />
        <Route
          path="/CustomerOrders/:customerId/:customerName"
          element={<CustomerOrdersScreen />}
        />
        <Route
          path="/CustomerMap"
          element={<CustomerMapScreen />}
        />
        <Route
          path="/SupplierOrders/:supplierId/:supplierName"
          element={<SupplierOrdersScreen />}
        />
        <Route
          path="/CustomerPresetPrices/:customerId/:customerName"
          element={<CustomerPresetPricesScreen />}
        />
        <Route
          path="/CustomerPayments/:customerId/:customerName"
          element={<CustomerPaymentsScreen />}
        />
        <Route
          path="/CustomerAnalytics/:customerId/:customerName"
          element={<CustomerAnalyticsScreen />}
        />
        <Route
          path="/Customer/:data"
          element={<AddCustomer />}
        />
         <Route
          path="/dashboard/PapaDCR"
          element={<DailyCallReportForm />}
        />
         <Route
          path="/dashboard/base64"
          element={<Base64 />}
        />
        <Route
          path="/dashboard/statsForNerds"
          element={<ServerStatsScreen />}
        />
        <Route
          path="/dashboard/pdfCompare"
          element={<PDFCompareScreen />}
        />
      </Routes>
      {pathname !== "/login" && <MobileFloatingIsland items={defaultMobileMenu}/>}
      </Stack>
      {/* </Box> */}
    </ChakraProvider>
  );
};

const AppWrapper = () => (
  <Router>
    <LoadScript googleMapsApiKey={GOOGLE_MAPS_API_KEY || ""} libraries={libraries}>
        <App />
    </LoadScript>
  </Router>
);
export default AppWrapper;
